import type { SelectOption } from '@purolator/ui-kit-angular';

/** Default phone country code for Canadian shipments. */
export const DEFAULT_PHONE_COUNTRY_CODE = '+1';

/**
 * Phone country code options for the address phone field group.
 */
export const PHONE_COUNTRY_CODE_OPTIONS: SelectOption[] = [{ value: '+1', label: '+ 1' }];
